/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, HelpBlock } from 'react-bootstrap';
//import Select from '../Select';
import InputText from '../InputText/InputText';
import './InputOfficePhone.css';

const InputOfficePhone = (props) => {
    const {
        countryCodeContent,
        areaCodeContent,
        phoneNumContent,
        officePhoneChangeAction,
        questionRel,
        isError,
        errorMessage,
        disabled,
        countryOverlapLabel,
        handleBlurAction
    } = props;

    const valueDidChange = (values) => {
        const finalValue = values.join("-");
        officePhoneChangeAction && officePhoneChangeAction(questionRel, finalValue);
    };

    const handlePhone = (index) => (rel, val) => {
        const countryCode = countryCodeContent.textValue;
        const areaCode = areaCodeContent.textValue;
        const phoneNum = phoneNumContent.textValue;
        
        switch (index) {
            case 0:
                valueDidChange([val, areaCode, phoneNum]);
                break;
            case 1:
                valueDidChange([countryCode, val, phoneNum]);
                break;
            case 2:
                valueDidChange([countryCode, areaCode, val]);
                break;
            default:
                break;
        }
    };

    return (
        <div className="phone-text-box clearfix">
            <FormGroup validationState={ isError ? 'error' : null }>
                <Row className="input-date-wrap phone-number-wrap combined-group-wrap">
                    <Col xs={4} md={4} lg={4} className="group-item country-code reserved-item-input">
                       {/* <Select
                            content={ countryCodeContent }
                            onChangeAction={ countryCodeChangeAction }
                            defaultValue={ countryCodeContent.defaultValue }
                            disabled={ disabled }
                            colParameter={{md: 12, xs: 12}}
                        />*/}
                        <InputText
                            handleTextChange={ handlePhone(0) }
                            content={ countryCodeContent }
                            colParameter={{md: 12, xs: 12}}
                            disabled={ disabled }
                            maxLength={3}
                            type={'tel'}
                            overlapLabel={countryOverlapLabel}
                            handleBlurAction={handleBlurAction}
                            ariaDescribedby={`${questionRel.questionId}-fieldError`}
                        />
                    </Col>

                    <Col xs={3} md={3} lg={3} className="group-item area-code">
                        <InputText
                            handleTextChange={ handlePhone(1) }
                            content={ areaCodeContent }
                            colParameter={{md: 12, xs: 12}}
                            disabled={ disabled }
                            maxLength={6}
                            type={'tel'}
                            handleBlurAction={handleBlurAction}
                            ariaDescribedby={`${questionRel.questionId}-fieldError`}
                        />
                    </Col>

                    <Col xs={5} md={5} lg={5} className="group-item phone-number">
                        <InputText
                            handleTextChange={ handlePhone(2) }
                            content={ phoneNumContent }
                            colParameter={{md: 12, xs: 12}}
                            disabled={ disabled }
                            maxLength={11}
                            type={'tel'}
                            handleBlurAction={handleBlurAction}
                            ariaDescribedby={`${questionRel.questionId}-fieldError`}
                        />
                    </Col>
                </Row>
                <HelpBlock id = {`${questionRel.questionId}-fieldError`}>{ errorMessage }</HelpBlock>
            </FormGroup>
        </div>
    )
};


InputOfficePhone.propTypes = {
    countryCodeContent: PropTypes.object.isRequired,
    areaCodeContent: PropTypes.object.isRequired,
    phoneNumContent: PropTypes.object.isRequired,
    officePhoneChangeAction: PropTypes.func,
    questionRel: PropTypes.object,
    isError: PropTypes.bool,
    errorMessage: PropTypes.string,
    disabled: PropTypes.bool,
    handleBlurAction: PropTypes.func,
    countryOverlapLabel: PropTypes.object,
};

InputOfficePhone.defaultProps = {
    itemArray: [],
    disabled: false,
    countryOverlapLabel:{
        float: 'left',
        labelContent: '+'
    }
};

export default InputOfficePhone


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/InputOfficePhone/index.js